import {Injectable, ViewContainerRef} from '@angular/core';
import {
    DynamicComponentCreationOptions,
    DynamicComponentFactoryService,
    DynamicComponentPlaceOptions,
    DynamicComponentRef
} from '../../../../../components/dynamic-component';
import {WidgetSettingsComponent} from './widget-settings.component';

@Injectable()
export class WidgetSettingsComponentService extends DynamicComponentFactoryService {

    /** Ref of the single open settings window (undefined when closed) */
    public settingsComponentRef?: DynamicComponentRef<WidgetSettingsComponent>;

    private layerRef?: ViewContainerRef;

    public setLayerRef(viewContainerRef: ViewContainerRef): void {
        this.layerRef = viewContainerRef;
    }

    public close(): void {
        this.settingsComponentRef?.destroy(); // no-op if already closed
        this.settingsComponentRef = undefined;
    }

    public open(options?: DynamicComponentCreationOptions<WidgetSettingsComponent>): WidgetSettingsComponent {
        this.close();

        const ref: DynamicComponentRef<WidgetSettingsComponent> = this.create(WidgetSettingsComponent, {
            ...options,
            place: options?.place ?? this.requireDefaultPlace()
        });

        // It's called separately from `create` in order to not override configs `options`
        ref.configureComponent({
            dynComponentRef: ref,
            propagateClose:  () => this.close()
        });

        this.settingsComponentRef = ref;

        return ref.instance;
    }

    private requireDefaultPlace(): DynamicComponentPlaceOptions {
        if (!this.layerRef) {
            throw new Error(
                'WidgetSettingsComponentService: layerRef is not set, ' +
                'call setLayerRef() or pass place in the open() options.'
            );
        }
        return {viewContainerRef: this.layerRef};
    }
}
